import React, { useEffect } from "react";
import _ from "lodash";
import "./App.css";

import CustomRoutes from "./CustomRoutes";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import { UserProvider } from "./contexts/UserContext";
import Utils from "./Utils";
import { Login, HrFirstLogin, HrDashboard } from "./pages";
import DefaultLayout from "./layouts/DefaultLayout";
import AdminLayout from "./layouts/AdminLayout";
//import HrLayout from "./layouts/HrLayout";
import PhLayout from "./layouts/PhLayout";
import { initActivityTracker } from "./activityTracker";
import FloatingTimer from "./components/common/FloatingTimer";

function App(props) {
  useEffect(() => {
    if (process.env.REACT_APP_TIMER === "1") {
      const stopTracker = initActivityTracker();
      return () => {
        if (typeof stopTracker === "function") {
          stopTracker();
        }
      };
    }
  }, []);

  const RoutedLayout = () => (
    <Router basename={process.env.REACT_APP_BASENAME || ""}>
      <Routes>
        {CustomRoutes.map((route, index) => (
          <Route
            key={index}
            path={route.path}
            exact={route.exact || false}
            element={
              route.secure && !Utils.isLoggedIn() ? (
                <Navigate to={`/`} />
              ) : (
                <route.layout {...props}>
                  <route.component {...props} />
                </route.layout>
              )
            }
          />
        ))}
      </Routes>
    </Router>
  );

  const Provider = () => (
    <UserProvider>
      <RoutedLayout />
      {process.env.REACT_APP_TIMER === "1" && <FloatingTimer />}
    </UserProvider>
  );

  return <Provider />;
}

export default App;
